import { PDADataService } from '../../../services/base/PDADataService';

export class AttachmentsService extends PDADataService {
    protected prefixUrl: string = `Attachments`;

    async GetById(id: string) {
        return this.downloadFile(`${this.prefixUrl}/GetById?id=${id}`);
    }

    // Blob для просмотра в PDF/Word-вьювере (без скачивания на диск).
    async getBlobById(id: string): Promise<Blob> {
        return this.fetchBlob(`${this.prefixUrl}/GetById?id=${id}`);
    }
}
